import { appGeneratePath } from '@/shared/lib';

/** Шаблон адреса раздела экспертных заключений: заключение, вид его части и сама часть */
export const EXPERT_REPORT_ROUTE_PATH = '/expert-report/:reportId?/:type?/:itemId?' as const;

/** Вид части заключения, на которой открывается раздел */
export type ExpertReportItemType = 'report' | 'block' | 'group' | 'assessment';

/**
 * Адрес части заключения в разделе экспертных заключений.
 *
 * Свой шаблон адреса раздел задаёт один раз здесь: собранный конкатенацией адрес смену шаблона
 * переживает незаметно — он просто уводит в никуда.
 */
export const buildExpertReportItemPath = (reportId: number, type: ExpertReportItemType, itemId: number): string =>
  appGeneratePath(EXPERT_REPORT_ROUTE_PATH, {
    reportId: String(reportId),
    type,
    itemId: String(itemId),
  });
